import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function LoginWithSAML({ redirectUrl }: { redirectUrl: string }) {
  const params = new URLSearchParams({
    redirectUrl,
  });
  const url = `/internal/login/corp-saml?${params.toString()}`;
  return (
    <a href={url} className="social-button saml-button">
      <FontAwesomeIcon
        style={{ width: '18px', height: '18px', margin: '14px' }}
        icon="lock"
        className="social-button-icon"
      />
      <span className="social-button-text">LOG IN WITH SAML</span>
    </a>
  );
}
